import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { getEnvironment } from '../util/util';
import { axiosUnauth, axiosAuth } from '../apis/main.api';
import appConfig from '../config/appConfig';
import Error from './error';
import Csc from './csc';

function Loader() {
  const [ready, setReady] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const [accessToken, setAccessToken] = useState('');
  const [successRedirectUrl, setSuccessRedirectUrl] = useState('');
  const [encryptionKey, setEncryptionKey] = useState(null);
  const [showCsc, setShowCsc] = useState(false);
  const [error, setError] = useState(false);
  const [nodeEnv, setNodeEnv] = useState('e0');

  const cleanAll = () => {
    setSessionId('')
    setAccessToken('')
    setSuccessRedirectUrl('')
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const access_token = params.get('access_token') || '';
    const session_id = params.get('session_id') || '';

    if (!access_token || !session_id) {
      setReady(false);
      setError(true);
      cleanAll();
    } else {
      setAccessToken(access_token);
      setSessionId(session_id);
      setReady(true);
    }
  }, []);

  useEffect(() => {
    if (ready) {
      getAppEnv();
    }
  }, [ready]);

  const getAppEnv = () => {
    axiosUnauth
      .get('get_env')
      .then((responses) => {
        console.log('get_env', responses.data);
        setNodeEnv(responses.data.env);
        validateAuth(responses.data.env);
      })
      .catch((err) => {
        console.log('err', err);
        setError(true);
        cleanAll()
      });
  };

  const validateAuth = (env) => {
    axiosAuth.interceptors.request.use((config) => {
      config.baseURL = `${appConfig.config[getEnvironment(env)]?.url}`;
      config.headers['Authorization'] = `Bearer ${accessToken}`;
      return config;
    });

    axiosAuth
      .post('/transaction/metadata', { session_id: sessionId })
      .then((responses) => {
        setSuccessRedirectUrl(responses.data.redirect_url);
        setEncryptionKey(responses.data.encrypt_key)
        setShowCsc(true);
      })
      .catch((err) => {
        console.log('err', err);
        setError(true);
        cleanAll()
      });
  };

  if (error) {
    return <Error />;
  }

  if (showCsc) {
    return (
      <Csc
        sessionId={sessionId}
        accessToken={accessToken}
        successRedirectUrl={successRedirectUrl}
        nodeEnv={nodeEnv}
        encryptionKey={encryptionKey}
        setError={setError}
      />
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress></CircularProgress>
    </Box>
  );
}

export default Loader;
